import Axios from "axios";

import {
  SET_LOADING,
  UNSET_LOADING,
  SET_LOADING_COLOR,
  UNSET_LOADING_COLOR
} from "../mutation-types";

// initial state
const state = {
  loading: false,
  loading_color: "primary"
};

const getters = {
    getLoading(state){
        return state.loading;
    },
    getLoadingColor(state){
        return state.loading_color
    }
};

const mutations = {
  [SET_LOADING](state, payload) {
    state.loading = true;
    state.loading_color = payload.color;
  },
  [UNSET_LOADING](state) {
    state.loading = false;
  },
  [SET_LOADING_COLOR](state, value) {
    state.loading_color = value;
  },
  [UNSET_LOADING_COLOR](state) {
    state.loading_color = state.loading_color;
  },
};

const actions = {
  // sendUserEmail({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     params.append("base_url", frontendBaseUrl);
  //     Axios.post(sendUserEmail, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  // sendOTPCreateAccount({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     Axios.post(sendOTPCreateAccount, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  
  // verifyOTPCreateAccount({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     params.append("otp", data.otp);
  //     Axios.post(verifyOTPCreateAccount, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  // checkUserResetPasswordTime({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     Axios.get(checkUserResetPasswordTime + '/' + data.reset_code, data)
  //       .then(function (response) {
  //         resolve(response);
  //       }).catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
